module.exports = __webpack_public_path__ + "static/media/banner.91f5fa55.png";